module.exports = __webpack_public_path__ + "img/dog-human-meds.2cbff457.jpg";